module.exports = __webpack_public_path__ + "img/Kuljira.1b4382f5.jpg";